import { useState } from 'react';

import { useAccountSettings } from '@/entities/account';
import { Switch } from '@/shared/ui/Switch';

import { useUpdateAccountSettings } from '../model/useUpdateAccountSettings';
import { DisableTwoFaDialog } from './DisableTwoFaDialog';

export const TwoFaSwitcher = () => {
  const { accountSettings } = useAccountSettings();
  const { updateAccountSettings, isPending } = useUpdateAccountSettings();
  const [isDisableConfirmOpen, setDisableConfirmOpen] = useState(false);

  const handleChange2FaEnabled = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!event.target.checked) {
      setDisableConfirmOpen(true);
      return;
    }
    await updateAccountSettings({ twofa_is_active: event.target.checked });
  };

  return (
    <>
      <Switch
        checked={accountSettings?.twofa_is_active ?? true}
        onChange={handleChange2FaEnabled}
        disabled={isPending}
      />
      <DisableTwoFaDialog
        open={isDisableConfirmOpen}
        onClose={() => setDisableConfirmOpen(false)}
      />
    </>
  );
};
